import React, { useEffect, useRef } from 'react'
import Link from 'next/link'
import { uni1d800 } from '@/utils/extras'

const HeaderCrazy = () => {
    const logoRef = useRef(null)

    useEffect(() => {
        const adjustScale = () => {
            const pageWidth = window.innerWidth
            let scale: number

            if (pageWidth <= 400) {
                scale = 1
            } else if (pageWidth > 400 && pageWidth <= 1200) {
                scale = 1 + (0.7 * (pageWidth - 400)) / (1200 - 400)
            } else {
                scale = 1.7
            }
            if (logoRef.current) {
                // @ts-expect-error needs any
                logoRef.current.style.transform = `scale(${scale})`
                // @ts-expect-error needs any
                logoRef.current.style.transition = 'transform 1s ease-in-out' // Add this line
            }
        }

        adjustScale()

        window.addEventListener('resize', adjustScale)

        return () => window.removeEventListener('resize', adjustScale)
    }, [])

    return (
        <div ref={logoRef} className="scale_logo">
            <div className={'header-container'}>
                <div className="react-flow header-container">
                    <div className="animated-outer-shadow">
                        <div className="animated-inner-shadow">
                            <div className="react-flow__node react-flow__node-turbo nopan selectable">
                                <div className="wrapper gradient">
                                    <div className="inner">
                                        <div className="body">
                                            <div className="title">
                                                <Link href="/">
                                                    <h1 className={uni1d800.className + ' medium'}>
                                                        {'\uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                                                    </h1>
                                                    <h2 className={uni1d800.className + ' large'}>
                                                        {' '}
                                                        DeFi NFT Marketplace
                                                    </h2>
                                                    <div className="subline ">
                                                        <h2 className="gradient-text">
                                                            Your Token &#11042; Your Vote &#11042; Your Art
                                                        </h2>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderCrazy
